export { default as MaleIcon } from '~icons/tabler/gender-male';
